import {requestRoot} from '@/api/aRequestRoot.js'
import db from '@/api/jsDb/db.js'

//模拟链式request
export function request(url_parms) {
  return requestRoot(url_parms,data);
}

function Get_Paper_List(){
  let data = db.from(db.tb_data_collection).select();
  console.log(data);
  return data
}


function Get_Paper_preItem(query){
  let data = db.from(db.tb_data_collection_items)
  .where("paperId","=",query.paperId)
  .where("preRequired","=",1)
  .select();
  console.log(data);
  return data
}

function Get_Paper_dailyItem(query){

}

function Put_Paper_PreItem(query){
  console.log(query);
  let data = db.from(db.tb_data_collection_record).new()
  .set("recordId",db.tb_data_collection_record.newId())
  .set("paperId",query[0].paperId)
  .set("createTime","2021-01-03")
  // .set("collectionTitle",query[0].collectionTitle)
  for(let i=0;i<query.length;i++){
    data.set(query[i]["itemStore"],query[i]["userAnswer"])
  }
  data = data.insert().inserted;
  console.log(data);
  return data
}

function Put_Paper_Item(query){

}

function Put_Paper_Confirm(query){

}

function Get_Paper_Record(query){
  let data = db.from(db.tb_data_collection_record)
  .where("recordId","=",query.recordId)
  .select();
  
  let data2 = db.from(db.tb_data_collection_items)
  .where("paperId","=",data[0].paperId)
  .where("groupTitle","=",'')
  .select();

  let data3 = db.from(db.tb_data_collection_items)
  .where("paperId","=",data[0].paperId)
  .where("groupTitle","<>",'')
  .distinct("groupTitle")
  .select({groupTitle:"",paperId:""},db.from().objects);

  data3.forEach(item => {
    item["items"]=db.from(db.tb_data_collection_items)
    .where("paperId","=",item.paperId)
    .where("groupTitle","=",item.groupTitle).select();
  });
  console.log(data3)
  let data4 ={
    data:data,
    data2:data2,
    data3:data3,
  }
  console.log(data4);
  return data4
}

function Get_Paper_RecordList(query){
  let data = db.from(db.tb_data_collection_record)
  .where("paperId","=",query.paperId)
  .select();
  return data
}

function Get_Paper(query){
  console.log(query);
  let data = db.from(db.tb_data_collection)
  .where("itemId","=",query.paperId)
  .select();
 
  return data
}

function Det_Paper(query){

}

function Put_Paper_DailyItem(query){

}

function Get_Paper_notDailyItem(query){

}
function Get_Paper_RecordDailys(query){

}

  var data ={
    Get_Paper_List:Get_Paper_List,
    Get_Paper_preItem:Get_Paper_preItem,
    Put_Paper_PreItem:Put_Paper_PreItem,
    Get_Paper_Record:Get_Paper_Record,
    Get_Paper_RecordList:Get_Paper_RecordList,
    Get_Paper:Get_Paper,
    Put_Paper_Item:Put_Paper_Item,
    Put_Paper_Confirm:Put_Paper_Confirm,
    Det_Paper:Det_Paper,
    Get_Paper_dailyItem:Get_Paper_dailyItem,
    Put_Paper_DailyItem:Put_Paper_DailyItem,
    Get_Paper_notDailyItem:Get_Paper_notDailyItem,
    Get_Paper_RecordDailys:Get_Paper_RecordDailys,
}





// WEBPACK FOOTER //
// ./src/api/pageOne/ApiService.js